import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionAggregatedFilter = _resolveComponent("RegionAggregatedFilter")!
  const _component_RegionAggregatedBaseInfo = _resolveComponent("RegionAggregatedBaseInfo")!
  const _component_RegionAggregatedTable = _resolveComponent("RegionAggregatedTable")!
  const _component_AggregatedPageWrapper = _resolveComponent("AggregatedPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_AggregatedPageWrapper, {
        key: 0,
        title: "Агрегированные данные (Экспорт, импорт) по регионам",
        exportConfig: _ctx.getExportConfig
      }, {
        filter: _withCtx(() => [
          _createVNode(_component_RegionAggregatedFilter, {
            onSearchFilter: _ctx.searchFilter,
            onUpdateFilter: _ctx.updateFilter,
            onUpdateProductText: _ctx.setProductText,
            defaultFilter: _ctx.defaultFilter,
            readonlyPermissionCode: _ctx.getPermissions.build
          }, null, 8, ["onSearchFilter", "onUpdateFilter", "onUpdateProductText", "defaultFilter", "readonlyPermissionCode"])
        ]),
        "base-info": _withCtx(() => [
          _createVNode(_component_RegionAggregatedBaseInfo, {
            filter: _ctx.filter,
            productText: _ctx.productText
          }, null, 8, ["filter", "productText"])
        ]),
        table: _withCtx(() => [
          _createVNode(_component_RegionAggregatedTable, {
            filter: _ctx.filter,
            storePaths: _ctx.storePaths
          }, null, 8, ["filter", "storePaths"])
        ]),
        _: 1
      }, 8, ["exportConfig"]))
    : _createCommentVNode("", true)
}